import underMaintenance from 'assets/images/characters/error-robot.jpg';
import {Button} from 'components/ui';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useLogout} from 'APIs/letrusAPI/logout';
import styles from './ErrorPage.module.scss';

interface ErrorPageProps {
  isAuthed?: boolean;
}

function ErrorPage({isAuthed = true}: ErrorPageProps): JSX.Element {
  const [copied, setCopied] = useState(false);

  const logout = useLogout();
  const navigate = useNavigate();
  const storagedError = localStorage.getItem('sentryEvent');
  const errorCode = storagedError ? JSON.parse(storagedError).event_id : '';

  function copyErrorCode() {
    navigator.clipboard.writeText(errorCode);
    setCopied(true);
  }

  return (
    <div className={styles.wrapper}>
      <main className={styles.container}>
        <img
          alt=""
          aria-hidden
          className={styles.image}
          src={underMaintenance}
        />
        <h1>Ops! Algo não saiu como planejado</h1>
        <p>
          Estamos cuidando disso para que sua experiência educacional não seja
          interrompida.
        </p>

        <div className={styles.buttonsWrapper}>
          {isAuthed && (
            <>
              <Button
                text="Sair"
                variant="secondary"
                onClick={() => logout.trigger()}
                leftIcon={{icon: 'sign-out-alt', size: 'lg'}}
              />

              <Button
                variant="secondary"
                text="Página inicial"
                onClick={() => navigate('/')}
                leftIcon={{icon: ['fad', 'home'], size: 'lg'}}
              />
            </>
          )}

          <Button
            variant="primary"
            text="Recarregar"
            onClick={() => navigate(0)}
            leftIcon={{icon: ['fad', 'repeat'], size: 'lg'}}
          />
        </div>

        <div className={styles.errorCard}>
          <p className={styles.errorTitle}>
            Código de identificação
            <Button
              text=""
              circular
              variant="tertiary"
              onClick={() => copyErrorCode()}
              leftIcon={{
                icon: copied ? ['fad', 'check-circle'] : ['fal', 'copy'],
                color: copied ? '#00c660' : '#2A5082',
                size: 'lg',
              }}
            />
          </p>
          <p className={styles.errorCode}>{errorCode}</p>
        </div>
      </main>
    </div>
  );
}

export default ErrorPage;
